<template>
  <div>
    <div class="buttons-wrapper mb-3">
      <div>
        <CButton
          class="mb-1"
          size="sm"
          color="primary"
          :disabled="isSelectionEmpty"
          @click="showResetModal = true"
        >
          Réinitialiser la sélection
        </CButton>
      </div>
      <div>
        <CButton
          class="mb-1"
          size="sm"
          style="background-color: #1131ae; color: white"
          :disabled="!this.selectedCerts.length"
          @click="processFile(
            ALUMNI_ENDPOINTS.linkedin_export,
            exportPayload,
            `Echec: merci de contacter l'administrateur​`,
            'Traitement en cours',
            'Donnée LinkedIn exportés avec succès',
            'Pas de données à enrichir pour les filtres sélectionnés',
          )"
        >
          Exporter les données LinkedIn
        </CButton>
      </div>
      <FileDragdrop @upload="importData">
        <template slot="upload-button">
          <CButton
            class="mb-1"
            size="sm"
            color="primary"
          >
            Injecter les données LinkedIn sélectionnés
          </CButton>
        </template>
      </FileDragdrop>
    </div>
    <div
      v-if="loadingMessage.length"
      class="d-flex justify-content-center w-100 mt-3"
    >
      <div class="d-flex justify-content-between align-items-center gap-3">
        <h3>{{ loadingMessage }}</h3>
        <dots-loader />
      </div>
    </div>
    <div class="d-flex flex-column gap-5 justify-content-center mt-5">
      <SelectionRow
        select-title="Sélectionner un type de diplôme / formation :"
        selected-title="Sélection des certifications:"
        :available-options="availableCertificationTypes"
        :selected="selectedCerts"
        @selection="fetchCerts"
        @removeSelection="removeCert"
      >
        <template slot="center">
          <div class="d-flex flex-column">
            <h5 class="text-muted">Ajouter un élément:</h5>
            <MzSelect
              searchable
              allow-unselect
              :multiple="true"
              class="w-100"
              :disabled="!selectedCertificationType"
              :options="availableSelection"
              @update:value="addSelection"
            />
          </div>
        </template>
        <template slot="selectionName" slot-scope="{ selection }">
          {{certNames[selection]}}
        </template>
      </SelectionRow>
      <SelectionRow
        v-for="option in ['promotions', 'duree_post_diplome', 'campaigns', 'ecoles']"
        :key="option"
        class="mt-2"
        :sync-value="false"
        :disableSelect="!selectedCerts.length"
        @selection="(v) => handleSelect(v, option)"
        @removeSelection="(v) => removeSelection(v, option)"
        :selected="selectedOptions[option]"
        :select-title="selectTitles[option].select"
        :selected-title="selectTitles[option].selected"
        :available-options="availableOptions[option]"
      >
        <template v-if="option === 'campaigns'" #selectionName="{ selection }" >
          {{allFetchedCampaignsMap[selection] || selection}}
        </template>
      </SelectionRow>
      <table-component
        v-if="showQualityIssuesTable"
        class="mt-3"
        :data="qualityCheckTableData"
        :filterable="false"
        :display-columns-selector="false"
        :columns="['unique_keys_with_multipe_urls', 'lkd_urls_with_multiple_unique_keys']"
        :headings="{
          unique_keys_with_multipe_urls: 'UNIQUE Keys avec plusieurs comptes LinkedIn sélectionnés',
          lkd_urls_with_multiple_unique_keys: 'Compte LinkedIn sélectionnés pour plusieurs UNIQUE keys',
        }"
      >
      </table-component>
    </div>
    <CModal
      :show.sync="showResetModal"
      :draggable="false"
      :resizable="false"
      centered
    >
      <template slot="header-wrapper"><span></span></template>
      La sélection en cours va etre supprimée
      <template slot="footer">
        <div>
          <CButton
            color="secondary"
            class="mr-2"
            @click="showResetModal = false"
          >
            Annuler
          </CButton>
          <CButton color="primary" @click="resetSelection"> Valider </CButton>
        </div>
      </template>
    </CModal>
  </div>
</template>

<script>
import { request } from "@/utils/request";
import {CertService} from "@/services/certification";
import { ALUMNI_ENDPOINTS, AlumniService } from "@/services/alumni";
import { FilesService } from "@/services/files";
import Task from "@/services/task";
import SelectionRow from "@/components/SelectionRow";

export default {
  name: "Rapport",
  components: {SelectionRow},
  data() {
    return {
      ALUMNI_ENDPOINTS,
      fetchSequence: 0,
      allFetchedCampaignsMap: {},
      availableCertificationTypes: [],
      campaignOptions: [],
      ecoleOptions: [],
      selectedCertificationType: null,
      selectedPromotions: [],
      certsData: [],
      allCertsData: [],
      selectedCerts: [],
      qualityCheckData: {},
      showQualityIssuesTable: false,
      selectedOptions: {
        promotions: [],
        duree_post_diplome: [],
        campaigns: [],
        ecoles: [],
      },
      loadingMessage: "",
      showResetModal: false,
      promotionOptions: [],
      dureePostDiplomeOptions: [
        "6 mois",
        "15 mois",
        "24 mois",
        "36 mois",
        "48 mois",
      ],
      selectTitles: {
        promotions: {
          select: "Sélectionner une promotion",
          selected: "Sélection des promotions:",
        },
        duree_post_diplome: {
          select: "Sélectionner une promotion",
          selected: "Sélection des durée post-diplôme:",
        },
        campaigns: {
          select: "Sélectionner une campagnes",
          selected: "Sélection des campagnes:",
        },
        ecoles: {
          select: "Sélectionner une écoles (UC)",
          selected: "Sélection des écoles (UC):",
        },
      },
      messageMapper: {
        "columns in the template not found":
          "Expected columns missing in template F7",
        "extra columns in data":
          "Unexpected columns found in template F7",
      },
      fichier6Message: {
        info: "Traitement en cours ...",
        success: "Analyse injectée dans la base de données",
        error: "Error: somthing went wrong",
      },
    };
  },
  watch: {
    selectedCerts() {
      this.fetchSequence++;
      const seq = this.fetchSequence;
      this.fetchPromotionOptions(seq);
      this.fetchFilters(seq);
    }
  },
  computed: {
    exportPayload() {
      return {
        certification_codes: this.selectedCerts,
        promotions_ls: this.selectedOptions.promotions.map(v => parseInt(v)),
        duree_post_diplome_ls: this.selectedOptions.duree_post_diplome.map(v => parseInt(v)),
        campaigns_ids_ls: this.selectedOptions.campaigns,
        ecoles_ls: this.selectedOptions.ecoles,
      }
    },
    availableSelection() {
      const options = this.certsData.filter(
        (cert) => !this.selectedCerts.includes(cert.value)
      );
      options.unshift({ label: "All", value: "All" });
      return options
    },
    availableOptions() {
      return {
        promotions: this.availablePromotionOptions,
        duree_post_diplome: this.availableDureePostDiplomeOptions,
        campaigns: this.availableCampaignOptions,
        ecoles: this.availableEcoleOptions,
      }
    },
    availableDureePostDiplomeOptions() {
      return [
        "All",
        ...this.dureePostDiplomeOptions.filter(
          (option) => !this.selectedOptions.duree_post_diplome.includes(option)
        )
      ]
    },
    availablePromotionOptions() {
      return [
        "All",
        ...this.promotionOptions.filter(
          (promotion) => !this.selectedOptions.promotions.includes(promotion)
        )
      ]
    },
    availableEcoleOptions() {
      return [
        "All",
        ...this.ecoleOptions.filter(
          (option) => !this.selectedOptions.ecoles.includes(option)
        )
      ]
    },
    availableCampaignOptions() {
      return [
        "All",
        ...this.campaignOptions.filter(
          (option) => !this.selectedOptions.campaigns.includes(option.value)
        )
      ]
    },
    isSelectionEmpty() {
      return (
        !this.selectedCerts.length
        && !this.selectedOptions.promotions.length
        &&!this.selectedOptions.duree_post_diplome.length
        &&!this.selectedOptions.campaigns.length
        &&!this.selectedOptions.ecoles.length
      )
    },
    qualityCheckTableData() {
      const keys = Object.keys(this.qualityCheckData)
      const maxLength = Math.max(...keys.map(
        key => (
          ["unique_keys_with_multipe_urls", "lkd_urls_with_multiple_unique_keys"].includes(key)
            ? this.qualityCheckData[key].length
            : 0
        )
      ));
      return Array.from({length: maxLength}, (_, i) => {
        const newObj = {};
        keys.forEach(key => {
          newObj[key] = this.qualityCheckData[key][i] !== undefined ? this.qualityCheckData[key][i] : null;
        })
        return newObj
      });
    },
    certNames() {
      return Object.fromEntries(
        this.allCertsData.map((certData) => {
          return [certData.value, certData.label];
        })
      );
    },
  },
  async mounted() {
    await this.fetchCerts('all', true);
    this.allCertsData = JSON.parse(JSON.stringify(this.certsData))
    await this.fetchCertTypes()
    this.fetchSequence++;
    this.fetchFilters(this.fetchSequence)
  },
  methods: {
    async fetchEcoleOptions(seq) {
      this.ecoleOptions = await AlumniService.getEcoleOptions(this.exportPayload) || []
      if (seq !== this.fetchSequence) return;
    },
    async fetchCampaignOptions(seq) {
      this.campaignOptions = await AlumniService.getCampaignOptions(this.exportPayload)  || []
      if (seq !== this.fetchSequence) return;
      this.allFetchedCampaignsMap = {
        ...this.allFetchedCampaignsMap,
        ...Object.fromEntries(this.campaignOptions.map(c => [c.value, c.label]))
      }
    },
    handleFiltersChanged() {
      this.selectedOptions.campaigns = this.selectedOptions.campaigns.filter(c => this.campaignOptions.map(co => co.value).includes(c))
      this.selectedOptions.ecoles = this.selectedOptions.ecoles.filter(e => this.ecoleOptions.includes(e))
    },
    async fetchFilters(seq) {
      await this.fetchEcoleOptions(seq)
      await this.fetchCampaignOptions(seq)
      if (seq !== this.fetchSequence) return;
      this.handleFiltersChanged()
    },
    async fetchCertTypes() {
      const types = await CertService.getTypes(true)
      this.availableCertificationTypes = [
        {
          label: "Tout sélectionner",
          value: "all"
        },
        ...types,
        {
          label: "Aucun type",
          value: "empty"
        },
      ]
    },
    async processFile(url, body, errorMessage, infoMessage, successMessage, noDataMessage) {
      const method = "POST";

      if (infoMessage.length) {
        this.loadingMessage = infoMessage;
      }

      const { res, data } = await request({
        url,
        method,
        body,
      });

      if (res.status !== 200) {
        this.loadingMessage = "";
        return alert(errorMessage);
      }

      const taskId = data.task_id;
      if (taskId) {
        const new_task = new Task(taskId);
        new_task.on("result", (result) => {
          if (result?.status) {
            this.handleChordLinkedin(result?.chord_id, errorMessage, successMessage, noDataMessage)
            alert(infoMessage);
          } else {
            alert(noDataMessage)
          }
        });
        new_task.on("error", (error) => {
          alert(errorMessage);
          this.loadingMessage = "";
        });
      }
    },
    handleChordLinkedin(taskId, errorMessage, successMessage, noDataMessage) {
      const new_task = new Task(taskId, 10000);
        new_task.on("result", (result) => {
          if (result?.status) {
            AlumniService.downloadFiche6(result.filename);
            alert(successMessage);
          } else {
            alert(noDataMessage)
          }
          this.loadingMessage = "";
        });
        new_task.on("error", (error) => {
          alert(errorMessage);
          this.loadingMessage = "";
        });
    },
    handleSelect(value, option) {
      if (this.selectedOptions[option].indexOf(value) === -1) {
        if (value === "All") {
          this.selectedOptions[option].push(
            ...this.availableOptions[option]
              .filter((v) => v !== "All")
              .map((v) => (typeof v === "object" ? v.value : v))
          )
        } else {
          this.selectedOptions[option].push(value);
        }
      }
    },
    async addSelection(value) {
      if (this.selectedCerts.indexOf(value) === -1) {
        if (value === "All") {
          this.selectedCerts.push(
            ...this.certsData
              .filter((cert) => !this.selectedCerts.includes(cert.value))
              .map((cert) => cert.value)
          );
        } else {
          this.selectedCerts.push(value);
        }
      }
    },
    async fetchCerts(type, initial=false) {
      if (!initial) {
        this.selectedCertificationType = type;
      }
      const { data } = await request({
        url: ALUMNI_ENDPOINTS.certs(type),
      });
      this.certsData = data.map((certData) => {
        return {
          label: certData.certification_name,
          value: certData.certification_code,
        };
      });
    },
    removeCert(value) {
      const index = this.selectedCerts.indexOf(value);
      if (index === -1) {
        return;
      }
      this.selectedCerts.splice(index, 1);
      this.selectedOptions.promotions = [];
      this.selectedOptions.campaigns = [];
      this.selectedOptions.ecoles = [];
    },
    removeSelection(value, option) {
      const index = this.selectedOptions[option].indexOf(value);
      if (index === -1) {
        return;
      }
      this.selectedOptions[option].splice(index, 1);
    },
    async resetSelection() {
      this.selectedCerts = [];
      this.selectedCertificationType = null;
      this.selectedOptions.promotions = [];
      this.selectedOptions.duree_post_diplome = [];
      this.selectedOptions.campaigns = [];
      this.selectedOptions.ecoles = [];
      this.showResetModal = false;
    },
    async fetchPromotionOptions(seq) {
      if (!this.selectedCerts.length) {
        this.promotionOptions = []
        return
      }
      this.promotionOptions = await AlumniService.getPromotionOptions({
        certification_codes: this.selectedCerts
      })
      if (seq !== this.fetchSequence) return;
    },
    handleDataInjection(taskId) {
      const injectionTask = new Task(taskId)
      injectionTask.on("result", () => {
        alert("Données injectées avec succès​​");
        this.loadingMessage = "";
      });
      injectionTask.on("progress", (progress) => {
//        if (progress?.filename) {
//          AlumniService.downloadFiche6(progress.filename);
//        }
      })
      injectionTask.on("error", (error) => {
        alert(error?.traceback)
        this.loadingMessage = "";
      });
    },
    async importData(files) {
      this.qualityCheckData = {};
      this.showQualityIssuesTable = false;
      this.loadingMessage = 'Traitement en cours'
      await FilesService.uploadFile({
        file: files[0],
        url: ALUMNI_ENDPOINTS.linkedin_import,
        onError: (response) => {
          this.loadingMessage = '';
          return alert(response.detail);
        },
        onSuccess: (response) => {
          if (response?.task_id) {
            alert("Fichier importé avec succès​​");
            this.handleDataInjection(response.task_id)
          }
          if (response["unique_keys_with_multipe_urls"].length) {
            alert("Données sélectionnées non compatibles​")
          }
          if (
            response["lkd_urls_with_multiple_unique_keys"].length
            || response["unique_keys_with_multipe_urls"].length
          ) {
            this.qualityCheckData = response;
            this.showQualityIssuesTable = true;
          }
          this.loadingMessage = ""
        }
      });
    },
  },
};
</script>
